import { CrewMerchantUi } from 'corso-types';

import { Action, Card, SimpleTooltip } from 'corso-admin-ui';

type Shipment = NonNullable<CrewMerchantUi.ClaimShipment>;

export default function ShipmentPackingSlip({
  shipment,
}: {
  shipment: Shipment;
}) {
  return (
    <div className="flex flex-col gap-2">
      <Card.Heading> Packing Slip </Card.Heading>
      {shipment.returnShipmentPdfAssetUrl && (
        <SimpleTooltip content="Download Packing Slip">
          <Action
            icon="download"
            to={shipment.returnShipmentPdfAssetUrl}
            accessibilityLabel="Download"
            download
          />
        </SimpleTooltip>
      )}
    </div>
  );
}
